import React from 'react'
import { Droppable } from 'react-beautiful-dnd'

const PatternTableWrapper = props => (
    <Droppable droppableId='droppable'>
        {provided => (
            <>
                <tbody ref={provided.innerRef} {...props} {...provided.droppableProps}></tbody>
                <tfoot>{provided.placeholder}</tfoot>
            </>
        )}
    </Droppable>
)

export default PatternTableWrapper
